import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PurchaseRequisition from "./pages/PurchaseRequisition";
import PurchaseRequisitionForm from "./pages/PurchaseRequisitionForm";
import RequisitionView from "./pages/RequisitionView";
import TenderOutcome from "./pages/TenderOutcome";
import SanctionProposal from "./pages/SanctionProposal";
import SanctionProposalForm from "./pages/SanctionProposalForm";
import SanctionProposalDetail from "./pages/SanctionProposalDetail";
import PurchaseOrders from "./pages/PurchaseOrders";
import PurchaseOrderForm from "./pages/PurchaseOrderForm";
import POView from "./pages/POView";
import PaymentRecommendation from "./pages/PaymentRecommendation";
import PaymentRecommendationForm from "./pages/PaymentRecommendationForm";
import ApprovalQueue from "./pages/ApprovalQueue";
import GRNList from "./pages/GRNList";
import GRNForm from "./pages/GRNForm";
import GRNView from "./pages/GRNView";
import PurchaseDashboard from "./pages/PurchaseDashboard";
import VendorManagement from "./pages/VendorManagement";
import { FaceVerifyKiosk, FaceManageKiosk, FaceSessionReport } from "./pages/FaceKiosk";
import { HRDashboard, HRShortlist, HRInterview, HRReport } from "./pages/HRRecruitment";
import Layout from "./components/Layout";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-slate-900 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton duration={6000} />
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* IIT-H Recruitment Exam Face Recognition Kiosk — PUBLIC, no auth */}
          <Route path="/exam-entry/face-verify" element={<FaceVerifyKiosk />} />
          <Route path="/exam-entry/manage" element={<FaceManageKiosk />} />
          <Route path="/exam-entry/report/:sessionId" element={<FaceSessionReport />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/purchase-dashboard" element={<ProtectedRoute><PurchaseDashboard /></ProtectedRoute>} />
          <Route path="/requisitions" element={<ProtectedRoute><PurchaseRequisition /></ProtectedRoute>} />
          <Route path="/requisitions/new" element={<ProtectedRoute><PurchaseRequisitionForm /></ProtectedRoute>} />
          <Route path="/requisitions/:id" element={<ProtectedRoute><RequisitionView /></ProtectedRoute>} />
          <Route path="/requisitions/:id/edit" element={<ProtectedRoute><PurchaseRequisitionForm /></ProtectedRoute>} />
          <Route path="/tender-outcomes" element={<ProtectedRoute><TenderOutcome /></ProtectedRoute>} />
          <Route path="/sanction-proposals" element={<ProtectedRoute><SanctionProposal /></ProtectedRoute>} />
          <Route path="/sanction-proposals/new" element={<ProtectedRoute><SanctionProposalForm /></ProtectedRoute>} />
          <Route path="/sanction-proposals/:id" element={<ProtectedRoute><SanctionProposalDetail /></ProtectedRoute>} />
          <Route path="/purchase-orders" element={<ProtectedRoute><PurchaseOrders /></ProtectedRoute>} />
          <Route path="/purchase-orders/new" element={<ProtectedRoute><PurchaseOrderForm /></ProtectedRoute>} />
          <Route path="/purchase-orders/:id" element={<ProtectedRoute><POView /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><PaymentRecommendation /></ProtectedRoute>} />
          <Route path="/payments/new" element={<ProtectedRoute><PaymentRecommendationForm /></ProtectedRoute>} />
          <Route path="/approvals" element={<ProtectedRoute><ApprovalQueue /></ProtectedRoute>} />
          <Route path="/grn" element={<ProtectedRoute><GRNList /></ProtectedRoute>} />
          <Route path="/grn/new" element={<ProtectedRoute><GRNForm /></ProtectedRoute>} />
          <Route path="/grn/:id" element={<ProtectedRoute><GRNView /></ProtectedRoute>} />
          <Route path="/vendors" element={<ProtectedRoute><VendorManagement /></ProtectedRoute>} />
          <Route path="/hr" element={<ProtectedRoute><HRDashboard /></ProtectedRoute>} />
          <Route path="/hr/shortlist" element={<ProtectedRoute><HRShortlist /></ProtectedRoute>} />
          <Route path="/hr/shortlist/:sessionId" element={<ProtectedRoute><HRShortlist /></ProtectedRoute>} />
          <Route path="/hr/interview" element={<ProtectedRoute><HRInterview /></ProtectedRoute>} />
          <Route path="/hr/interview/*" element={<ProtectedRoute><HRInterview /></ProtectedRoute>} />
          <Route path="/hr/report" element={<ProtectedRoute><HRReport /></ProtectedRoute>} />
          <Route path="/hr/report/:sessionId" element={<ProtectedRoute><HRReport /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
